import React from "react";
import {
  MDBSelect,
  MDBDatePicker,
  MDBAlert,
  MDBTableHead,
  MDBTable,
  ToastContainer,
  MDBTableBody,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import Loader from "../../Components/Loader";

import { API_CONFIG } from "../../Config/config-env.js";
import { OP_SECRET_KEY } from "../../Config/config-env.js";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { CASAIDEAS_LOGO_BASE64 } from "../../Config/assets/casaideasLogo";

/*functions*/
import {
  callexternalApi
} from "../../Config/functions";

const ref = React.createRef();

var f = new Date();
var fromDate = new Date();
fromDate.setDate(f.getDate() - 30);
var mes =
  f.getUTCMonth() + 1 < 10 ? "0" + (f.getUTCMonth() + 1) : f.getUTCMonth() + 1;
var dia = f.getUTCDate() < 10 ? "0" + f.getUTCDate() : f.getUTCDate();
var date_label = f.getUTCFullYear() + "-" + mes + "-" + dia;

class reportArqueo3 extends React.Component {
  state = {
    loadingData: true,
    optionsT: [
      { value: 47, checked: true, text: "Envio a Domicilio" },
      { value: 85, text: "Recojo en Tienda" },
    ],
    options: [],
    deliveryDate: date_label,
    sectionId: "",
    userType: 47,
    storeName: "",
    city: "",
    SKU: "",
    orderskus: [],
    orders: [],
    rows1: [],
    noData: false,
    rows2: [],
    skuExists: "NO ENCONTRADO",
    skuState: "SIN INFORMACION",
    showResults: false,
    data: [],
    customerinfo: [],
    addinfo: [],
    to_date: new Date(),
    from_date: new Date(),
    fecha: "",
    montoEvento: 0,
    generatingPdf: false,
  };

  componentDidMount = async () => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    let WO_Id = params.get("wfpflowid");
    var flowcode;
    let formButtons = [];
    let progress = 0;
    let isParent = false;
    let officecode = params.get("officecode");
    let _WOTaskId = params.get("wfptaskid").split("___");
    let WOTaskId = _WOTaskId[0];
    if (_WOTaskId.length === 2) {
      console.log("es multiple");
      isParent = true;
    }
    var eventId = 0;
    var montoEvento = 0;
    var ordersPicked = [];
    var nombre_recepcion = "";
    var arr = [];
    var orderskus = [];
    var validOrders = [];
    var isSupervisor, isAdmin, org, userId;
    var customerinfo = [];
    var addinfo = [];
    var regalos = "";
    let orders = [];
    let ordenes = [];
    var tipopedidos = [];
    var posicionracks = [];

    await axios({
      headers: {

        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/decrypt-token",
      //url : "http://localhost:4042/api/v1"+"/engine-users/decrypt-token",
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          userId = data.token.USERID;
          isSupervisor = data.token.USERGROUP === "SINGLEUSER" ? -1 : 1;
          isAdmin = data.token.USERGROUP === "ADMINECOM" ? 1 : -1;
          this.setState({
            ...this.state,
            username: data.token.USERNAME,
          });
        }
      });
    var flowvars = []
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      //url : "http://localhost:4042/api/v1"+"/engine-users/get-task-details",
      data: {
        wfptaskid: WOTaskId,
        isParent: isParent,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log("data", data);
        flowvars = data.flowvars
        if (data.task) {
          flowcode = data.task.FLOWCODE;
        }

        if (data.tasks) {
          flowcode = data.tasks[0].FLOWCODE;
        }

        if (data.status) {
          for (let v in data.flowvars) {
            let flowVar = data.flowvars[v];
            let order_id = 0;
            let flowid = flowVar.WFPFLOWID;
            if (flowVar.VARNAME === "order_id") {
              order_id = Number(flowVar.VARVALUE);

              let customer_id = "";
              let pedido_parcial = "";
              let mixed_skus = [];
              for (let v2 in data.flowvars) {
                let flowVar2 = data.flowvars[v2];

                this.setState({ [flowVar2.VARNAME]: flowVar2.VARVALUE });

                if (flowVar2.WFPFLOWID == flowid) {
                  if (flowVar2.VARNAME === "customer_id") {
                    customer_id = flowVar2.VARVALUE;
                  }

                  if (flowVar2.VARNAME === "pedido_parcial") {
                    pedido_parcial = flowVar2.VARVALUE;
                  }

                  if (flowVar2.VARNAME === "mixed_skus") {
                    try {
                      mixed_skus = JSON.parse(flowVar2.VARVALUE);
                    } catch (ex) {
                      console.log("EX", ex);
                    }
                  }

                  if (flowVar2.VARNAME === "eventId") {
                    eventId = flowVar2.VARVALUE;
                  }

                  if (flowVar2.VARNAME == "nombre_recepcion") {
                    nombre_recepcion = flowVar2.VARVALUE;
                  }
                }
              }
              orders.push({
                order_id,
                customer_id,
                pedido_parcial,
                mixed_skus,
              });
              ordenes.push({
                ID_HFLUJO: flowid,
                NOMBRE: "order_id",
                VALOR: order_id,
              });
              validOrders.push(order_id);
            }

            if (flowVar.VARNAME === "tipo_pedido") {
              tipopedidos.push({
                ID_HFLUJO: flowid,
                NOMBRE: "tipo_pedido",
                VALOR: flowVar.VARVALUE,
              });
            }

            if (flowVar.VARNAME === "posicion_rack") {
              posicionracks.push({
                ID_HFLUJO: flowid,
                NOMBRE: "posicion_rack",
                VALOR: flowVar.VARVALUE,
              });
            }

            if (flowid == WO_Id) {
              if (flowVar.VARNAME === "ordersPicked") {
                ordersPicked = (flowVar.VARVALUE + "").split(",");
              }
              if (flowVar.VARNAME === "progress") {
                progress = parseInt(flowVar.VARVALUE);
              }
            }
          }
        }
      });

    var storeName = "";
    var city = "";
    var dataE = {
      id: eventId,
      apikey: API_CONFIG.casaideasIntToken
    };
    var api_urlV2 = API_CONFIG.casaideasInt;

    let resp3 = await callexternalApi(
      api_urlV2,
      "/api/frontend/getDomain",
      "post",
      { domainName: "tiendas" }
    );
    
    const stores = resp3.response
    await axios({
      method: "post",
      // headers: {  'Access-Control-Allow-Origin':'*' },
      url:
        API_CONFIG.casaideasInt +
        "/api/events/getById",
      data: dataE,
    })
      .then((response) => response.data)
      .then(async (data) => {
        if (data.success) {
          console.log("data", data)

          let matchS = stores.find(e => Number(e.id) === Number(data.response.storeid));
          console.log("store", matchS)
          storeName = matchS.tienda

          var d = data.response.datos_personales[0];
          customerinfo.push({ name: "nombre", value: d.firstname });
          customerinfo.push({ name: "apellido", value: d.alstname });
          customerinfo.push({ name: "Email", value: d.email });
          customerinfo.push({ name: "Telefono", value: d.phone });
          customerinfo.push({ name: "Documento", value: d.numdoc });

          var add = data.response.directions;
          regalos = data.response.regalosenvueltos;

          addinfo.push({ name: "Ciudad", value: add.city });
          addinfo.push({ name: "Direccion", value: add.address });
          addinfo.push({ name: "Indicaciones", value: add.reference });
          addinfo.push({ name: "Latitud", value: add.latitude });
          addinfo.push({ name: "Longitud", value: add.longitude });

          const eventAddress = add.address + ", Referencia: " + add.reference + " " + add.city
          this.setState({ eventAddress })
          for (var key in data.response.ordenes) {
            let order = data.response.ordenes[key];
            let isPicked =
              ordersPicked.indexOf(String(order.orderid)) >= 0 ? 1 : -1;
            let products = [];
            let TOTAL = 0

            for (let i in order.products) {
              let prod = order.products[i]
              let match = data.response.productos.find(e => e.sku === prod.sku);
              if (!match) {
                console.log("buscamos regalo extra para", prod.sku)
                let url_path_prd_prod = process.env.REACT_APP_APIPRD_CONFIG
                const response = await axios.get(url_path_prd_prod, {
                  params: {
                    custom: true,
                    SKU: prod.sku
                  },
                  headers: {
                    "Content-Type": "application/json"
                  }
                });
                match = response.data.result[0];
                match.isExtra = true
              }

              prod.image = "https://cidev-media.s3.amazonaws.com" + match?.images_path + prod.sku + "_1.jpg"
              prod.price = match?.price
              prod.total = prod.quantity * (match.price ?? 0)
              prod.isExtra = match.isExtra
              prod.name = match?.specific_name
              products.push(prod);
              TOTAL += prod.total
            }

            montoEvento = montoEvento + TOTAL;


            if (validOrders.indexOf(Number(order.orderid)) >= 0) {

              arr.push({
                id: key,
                orderid: Number(order.orderid),
                fecha: order.DATEADDED,
                total: TOTAL,
                nombre: order.nombre_invitado,
                storename: storeName,
                dedicacion_invitado: order.dedicacion_invitado,
                isPicked: isPicked,
                products: products,
              });
            }
          }
          arr = arr.sort(function (a, b) {
            return parseInt(a.orderid) - parseInt(b.orderid);
          });

          /*
          for (var key in data.response.ordenes) {
            let order = data.response.ordenes[key];
            let isPicked =
              ordersPicked.indexOf(String(order.orderid)) >= 0 ? 1 : -1;
            let products = [];
            let TOTAL = 0
            data.response.products.map(function (prod) {
              if (order.ORDERID == prod.order_id) {
                products.push(prod);
              }
            });
            if (validOrders.indexOf(order.ORDERID + "") >= 0) {
              arr.push({
                id: key,
                orderid: order.ORDERID + "",
                fecha: order.DATEADDED,
                total: order.TOTAL,
                storename: order.STORENAME,
                nombre: order.FIRSTNAME ? order.FIRSTNAME : "-",
                apellido: order.LASTNAME ? order.LASTNAME : "-",
                isPicked: isPicked,
                products: products,
              });
            }
          }
          */

          var datosOrdenes = [];

          tipopedidos.map(function (tipo) {
            var orderid;
            var tipopedido = tipo.VALOR;
            var flujo = tipo.ID_HFLUJO;

            ordenes.map(function (orden) {
              if (flujo == orden.ID_HFLUJO) {
                orderid = orden.VALOR;
              }
            });
            datosOrdenes.push({
              flujo: flujo,
              orderid: orderid,
              tipopedido: tipopedido,
            });
          });
          //console.log("datosOrdenes", datosOrdenes);
          /*
          data.response.orderDetails.map(function (sku) {
            let ordersku = sku;
            for (var key in data.response.order) {
              if (sku.ORDERID == data.response.order[key].ORDERID) {
                ordersku["DATEADDED"] = data.response.order[key].DATEADDED;
                ordersku["FIRSTNAME"] = data.response.order[key].FIRSTNAME;
                ordersku["LASTNAME"] = data.response.order[key].LASTNAME;
                ordersku["TOTAL"] = data.response.order[key].TOTAL;
                ordersku["EVENTID"] = eventId;
              }
            }
            var tipoPedido = "";
            datosOrdenes.map(function (orden) {
              if (sku.ORDERID == orden.orderid) {
                tipoPedido = orden.tipopedido;
              }
            });
            ordersku["ORDERTYPE"] = tipoPedido;
            //console.log(ordersku)
            if (ordersku.ORDERTYPE.toUpperCase().indexOf("NO xflow") < 0) {
              if (validOrders.indexOf(sku.ORDERID + "") >= 0) {
                let pos = -1;
                orderskus.map(function (key, item) {
                  if (key["SKU"] == ordersku["SKU"]) {
                    pos = item;
                  }
                });
                if (pos >= 0) {
                  orderskus[pos]["QUANTITY"] =
                    orderskus[pos]["QUANTITY"] + ordersku["QUANTITY"];
                } else {
                  orderskus.push({
                    SKU: ordersku["SKU"],
                    PRODUCTNAME: ordersku["PRODUCTNAME"],
                    QUANTITY: ordersku["QUANTITY"],
                  });
                }
              }
            }
          });
          */
          orderskus = [];

          console.log("ordenes", ordenes);
          console.log("posicionracks", posicionracks);
          console.log("tipopedidos", tipopedidos);

          const formatBoliviaDate = (unixTime) => {
            // Si viene en segundos, convertir a milisegundos
            if (unixTime.toString().length === 10) {
              unixTime *= 1000;
            }

            return new Intl.DateTimeFormat("es-BO", {
              timeZone: "America/La_Paz",
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false
            }).format(new Date(unixTime));
          };

           
          for (let i in data.response.ordenes) {
            let ordersku = data.response.ordenes[i]

            //console.log("order", ordersku.orderid)
            for (var key in ordersku.products) {
              let sku = ordersku.products[key]

              //console.log("sku", sku.sku)

              var tipoPedido = "";
              datosOrdenes.map(function (orden) {
                if (sku.ORDERID == orden.orderid) {
                  tipoPedido = orden.tipopedido;
                }
              });

              //ordersku["DATEADDED"] = new Date(ordersku.datetime);
              sku["DATEADDED"] = formatBoliviaDate(ordersku.datetime);
              sku["nombre_invitado"] = ordersku.nombre_invitado;
              sku["LASTNAME"] = "";//data.response.order[key].LASTNAME;
              sku["TOTAL"] = sku.TOTAL || 0;
              sku["EVENTID"] = eventId;
              sku["SKU"] = sku.sku
              let match = data.response.productos.find(e => e.sku === sku.sku);
              if (!match) {
                console.log("buscamos regalo extra para", sku.sku)
                let url_path_prd_prod = process.env.REACT_APP_APIPRD_CONFIG
                const response = await axios.get(url_path_prd_prod, {
                  params: {
                    custom: true,
                    SKU: sku.sku
                  },
                  headers: {
                    "Content-Type": "application/json"
                  }
                });
                match = response.data.result[0];
                match.isExtra = true
              }

              sku.QUANTITY = sku?.quantity
              sku.PRICE = (match.price ?? 0)
              sku.ORDERID = ordersku.orderid
              sku.isExtra = match.isExtra
              sku.PRODUCTNAME = match?.specific_name
              sku.TOTAL = sku.quantity * (match.price ?? 0)
              sku.product_id = match.id
              sku.STORENAME = ordersku.storename

              let flowId = 0
              for (let i in flowvars) {
                let v = flowvars[i]
                if (v.VARNAME === "order_id" && String(v.VARVALUE) === String(ordersku["orderid"])) {
                  flowId = flowvars[i].WFPFLOWID
                }
              }
              let sendstore = ""
              for (let i in flowvars) {
                let v = flowvars[i]
                if (v.WFPFLOWID === flowId && v.VARNAME === "sendstore") {
                  sendstore = v.VARVALUE
                }
              }
              if (flowId === 0) {
                console.log("pedido externo", sku)
                sendstore = "CLIENTE"
              }
              sku.sendstore = sendstore
              //console.log("data", flowId, ordersku["orderid"], sku["SKU"], sendstore)

              let trx = ""
              for (let i in flowvars) {
                let v = flowvars[i]
                if (v.WFPFLOWID === flowId && (v.VARNAME).toUpperCase() === "TRX") {
                  trx = v.VARVALUE
                }
              }
              sku.TRX = trx

              let storename =""

               for (let i in flowvars) {
                let v = flowvars[i]
               
                if (v.WFPFLOWID === flowId ) {
                  trx = v.VARVALUE
                   //console.log("flowId,",flowId, v.VARNAME, v.VARVALUE)
                }
              }
              /*
                STORENAME: storename,
                  STORE: store,
                  TRX: trx,
                  sendstore: sendstore
                  */
              if (validOrders.indexOf(Number(ordersku.orderid)) >= 0) {
                orderskus.push(sku);
              }
            }
          }
          //console.log("orderskus", orderskus)

          /*
          data.response.orderDetails.map(function (sku) {
            let pos = data.response.order.findIndex((item) => item.ORDERID === sku.ORDERID);

            let storename = data.response.order[pos].STORENAME
            let flowId = 0
            for (let i in flowvars) {
              let v = flowvars[i]
              if (v.VARNAME === "order_id" && v.VARVALUE.toString() === sku["ORDERID"].toString()) {
                flowId = flowvars[i].WFPFLOWID
              }
            }

            let trx = ""
            for (let i in flowvars) {
              let v = flowvars[i]
              if (v.WFPFLOWID === flowId && (v.VARNAME).toUpperCase() === "TRX") {
                trx = v.VARVALUE
              }
            }

            let store = ""
            for (let i in flowvars) {
              let v = flowvars[i]
              if (v.WFPFLOWID === flowId && v.VARNAME === "store") {
                store = v.VARVALUE
              }
            }

            let sendstore = ""
            for (let i in flowvars) {
              let v = flowvars[i]
              if (v.WFPFLOWID === flowId && v.VARNAME === "sendstore") {
                sendstore = v.VARVALUE
              }
            }
            if (flowId === 0) {
              sendstore = "CLIENTE"
            }

            orderskus.push({
              ORDERID: sku["ORDERID"],
              SKU: sku["SKU"],
              PRODUCTNAME: sku["PRODUCTNAME"],
              QUANTITY: sku["QUANTITY"],
              STORENAME: storename,
              STORE: store,
              TRX: trx,
              sendstore: sendstore
            });
          });
          */
        }
      });

    orderskus = orderskus.sort(function (a, b) {
      return parseInt(a.SKU) - parseInt(b.SKU);
    });

    //console.log("orderskus",orderskus,tipopedidos, ordenes )

    console.log("orderskus", orderskus);
    if (orderskus.length <= 0) {
      this.setState({ ...this.state, noData: true });
    } else {
      this.setState({ ...this.state, showResults: true });
    }

    this.setState({
      ...this.state,
      loadingData: false,
      orderskus: orderskus,
      store_url: API_CONFIG.casaideas,
      storeName: storeName,
      city: city,
      customerinfo: customerinfo,
      addinfo: addinfo,
      montoEvento: montoEvento,
      orders: arr,
      regalos: regalos,
    });
  };

  pairRows = (items) => {
    const rows = [];
    for (let i = 0; i < items.length; i += 2) {
      rows.push([
        items[i].name, items[i].value,
        items[i + 1] ? items[i + 1].name : "",
        items[i + 1] ? items[i + 1].value : "",
      ]);
    }
    return rows;
  };

  generatePdf = () => {
    this.setState({ generatingPdf: true });
    try {
      // Tonos tomados del logo real de Casaideas (wordmark taupe + acento rojo del R).
      const brand = [110, 100, 90]; // #6e645a
      const brandLight = [241, 238, 233];
      const accentRed = [214, 21, 60]; // #d6153c
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
      const pageW = doc.internal.pageSize.getWidth();
      const ml = 10;
      let y = 0;

      const logoW = 32;
      const logoH = logoW * (1204 / 4962);
      doc.addImage(CASAIDEAS_LOGO_BASE64, "PNG", ml, 6, logoW, logoH, undefined, "FAST");

      doc.setTextColor(...brand);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("NOTA DE ENTREGA", pageW - ml, 10, { align: "right" });
      doc.setFontSize(8.5);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Evento: ${this.state.eventName || "-"}    |    Ciudad: ${this.state.city || "-"}`,
        pageW - ml, 15.5, { align: "right" }
      );

      doc.setDrawColor(...accentRed);
      doc.setLineWidth(0.8);
      doc.line(ml, 19, pageW - ml, 19);
      y = 24;

      const sectionHeader = (title) => {
        doc.setFillColor(...brandLight);
        doc.rect(ml, y, pageW - 2 * ml, 6, "F");
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(...brand);
        doc.text(title, ml + 3, y + 4.2);
        doc.setTextColor(30, 30, 30);
        y += 8;
      };

      const pairRows = this.pairRows;

      const infoTableOpts = {
        theme: "grid",
        styles: { fontSize: 8.5, cellPadding: 2 },
        columnStyles: {
          0: { fontStyle: "bold", fillColor: [250, 249, 247], cellWidth: 45 },
          2: { fontStyle: "bold", fillColor: [250, 249, 247], cellWidth: 45 },
        },
        margin: { left: ml, right: ml },
      };

      sectionHeader("DATOS DEL CLIENTE");
      autoTable(doc, { startY: y, body: pairRows(this.state.customerinfo), ...infoTableOpts });
      y = doc.lastAutoTable.finalY + 4;

      sectionHeader("DATOS DEL EVENTO");
      autoTable(doc, {
        startY: y,
        body: [
          ["Código Evento", this.state.eventId || "-", "Nombre Evento", this.state.eventName || "-"],
          ["Tipo de Evento", this.state.eventType || "-", "Fecha del Evento", this.state.eventDate || "-"],
          ["Fecha Fin Recepción Regalos", this.state.eventEndDate || "-", "Monto Total", (this.state.montoEvento || 0) + " Bs."],
        ],
        ...infoTableOpts,
      });
      y = doc.lastAutoTable.finalY + 4;

      sectionHeader("DATOS DE DIRECCIÓN");
      autoTable(doc, { startY: y, body: pairRows(this.state.addinfo), ...infoTableOpts });
      y = doc.lastAutoTable.finalY + 4;

      sectionHeader("ORIGEN Y DESTINO DEL ENVÍO");
      autoTable(doc, {
        startY: y,
        body: [
          ["Tienda", this.state.storeName || "-", "Dirección", this.state.eventAddress || "-"],
          ["Fecha Evento", this.state.eventDate || "-", "Fecha Entrega", this.state.deliveryDate || "-"],
        ],
        ...infoTableOpts,
      });
      y = doc.lastAutoTable.finalY + 4;

      const items = this.state.orderskus.filter(sku => sku.sendstore !== "CLIENTE");
      sectionHeader("DETALLE DE PRODUCTOS");
      autoTable(doc, {
        startY: y,
        head: [["Tienda Registro", "ORDERID", "TRX", "SKU", "Descripción", "Unidades", "Observaciones", "Check"]],
        body: items.map(sku => [
          sku.STORE || sku.STORENAME, sku.ORDERID, sku.TRX, sku.SKU, sku.PRODUCTNAME, sku.QUANTITY, "", "",
        ]),
        theme: "striped",
        headStyles: { fillColor: brand, textColor: 255, fontSize: 8 },
        bodyStyles: { fontSize: 8, cellPadding: 2.2 },
        columnStyles: {
          5: { halign: "center", cellWidth: 20 },
          7: { halign: "center", cellWidth: 16 },
        },
        margin: { left: ml, right: ml },
      });
      y = doc.lastAutoTable.finalY + 10;

      const pageH = doc.internal.pageSize.getHeight();
      if (y + 34 > pageH - 10) {
        doc.addPage();
        y = 15;
      }

      const signW = (pageW - 2 * ml - 20) / 2;
      doc.setDrawColor(150, 150, 150);
      doc.rect(ml, y, signW, 22, "S");
      doc.rect(ml + signW + 20, y, signW, 22, "S");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(90, 90, 90);
      doc.text("Entregado por (Firma y Nombre / C.I.)", ml + signW / 2, y + 27, { align: "center" });
      doc.text("Recibido por (Firma y Nombre / C.I.)", ml + signW + 20 + signW / 2, y + 27, { align: "center" });

      const totalPages = doc.internal.getNumberOfPages();
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.text(`Pag. ${p} de ${totalPages}`, pageW - ml, pageH - 4, { align: "right" });
      }

      doc.save("NotaEntrega.Evento." + this.state.eventName + ".pdf");
    } finally {
      this.setState({ generatingPdf: false });
    }
  };

  render() {
    return (
      <>
        <Loader idLoading={this.state.loadingData} />
        <MDBContainer
          fluid
          className="justify-content-left text-left "
          style={{ marginLeft: "0" }}
        >
          <Loader idLoading={this.state.generatingPdf} />

          <h3
            style={{
              zIndex: "1000",
              fontWeight: "600",
              color: "#000",
              rginLeft: "0.5rem",
            }}
          >
            {" "}
            Datos del Evento
          </h3>

          <MDBRow className="pl-2">
            <MDBCol sm="12" style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
              Datos del Cliente
            </MDBCol>
          </MDBRow>
          <MDBRow className="pl-2">
            {this.state.customerinfo.map((c) => (
              <MDBCol sm="6">
                <MDBInput
                  value={c.value}
                  disabled={true}
                  label={c.name}
                ></MDBInput>
              </MDBCol>
            ))}
          </MDBRow>

          <MDBRow className="pl-2">
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              C&oacute;digo Evento:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {this.state.eventId}
              </span>
            </MDBCol>
          </MDBRow>

          <MDBRow className="pl-2">
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              Nombre Evento:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {this.state.eventName}
              </span>
            </MDBCol>
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              Fecha del Evento:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {this.state.eventDate}
              </span>
            </MDBCol>
          </MDBRow>

          <MDBRow className="pl-2">
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              Tipo de Evento:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {this.state.eventType}
              </span>
            </MDBCol>
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              Fecha Fin Recepcion Regalos:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {this.state.eventEndDate}
              </span>
            </MDBCol>
          </MDBRow>

          <MDBRow className="pl-2">
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              Cantidad de Pedidos:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {/*this.state.orders.length*/}
              </span>
            </MDBCol>
            <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
              Monto Total:
            </MDBCol>
            <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
              <span
                style={{
                  fontWeight: "600",
                }}
              >
                {this.state.montoEvento + "Bs."}
              </span>
            </MDBCol>
          </MDBRow>

          {/*
							   	<MDBRow className="pl-2" > 
							   		 
										<MDBCol sm="6" md="3" lg="2" style={{fontSize:"1.25rem"}} >
											Nombre de quien recibe los regalos:
										</MDBCol>  
										<MDBCol sm="6" md="3" lg="4" style={{fontSize:"1.25rem"}} >
										 
											<span style={{ 
														   	 	fontWeight:"600", 
														   	}}> 
											 {this.state.nombre_recepcion}
											</span>
										</MDBCol>  

										<MDBCol sm="6" md="3" lg="2" style={{fontSize:"1.25rem"}} >
											Regalos envueltos:
										</MDBCol>  
										<MDBCol sm="6" md="3" lg="4" style={{fontSize:"1.25rem"}} >
										
											<span style={{ 
																fontWeight:"600", 
															}}> 
											{this.state.regalos}
											</span>
										</MDBCol>  
									 
							   	</MDBRow> 
							   	*/}

          <MDBRow className="pl-2">
            <MDBCol sm="12" style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
              Datos de Direccion
            </MDBCol>
          </MDBRow>
          <MDBRow className="pl-2">
            {this.state.addinfo.map((c) => (
              <MDBCol sm="12">
                <MDBInput
                  value={c.value}
                  disabled={true}
                  label={c.name}
                ></MDBInput>
              </MDBCol>
            ))}
          </MDBRow>

          <br></br>

          {this.state.noData ? (
            <>
              {" "}
              <br />
              <MDBAlert color="warning" dismiss>
                No se encontraron datos para el periodo seleccionado
              </MDBAlert>
            </>
          ) : (
            ""
          )}
          {this.state.showResults ? (
            <>
              <div className="xext-report-pdf-bar">
                <MDBBtn
                  key="find"
                  size="sm"
                  color="danger"
                  onClick={this.generatePdf}
                  disabled={this.state.generatingPdf}
                >
                  {this.state.generatingPdf ? "Generando..." : "Generar Formulario"}
                </MDBBtn>
              </div>
              <MDBRow>
                <MDBCol sm="12" md="12" lg="12" xl="12">
                  <div ref={ref} className="xext-report-preview-wrap">
                    {/* Header de la nota */}
                    <div
                      style={{
                        background: "#6e645a",
                        borderRadius: "10px 10px 0 0",
                        color: "#fff",
                        marginBottom: "16px",
                        padding: "14px 20px",
                        borderBottom: "3px solid #d6153c",
                      }}
                    >
                      <div style={{ fontSize: "0.72rem", fontWeight: 600, letterSpacing: "0.1em", opacity: 0.85, textTransform: "uppercase" }}>
                        Nota de Entrega
                      </div>
                      <div style={{ fontSize: "1.05rem", fontWeight: 700, marginTop: "2px" }}>
                        {this.state.eventName}
                      </div>
                      <div style={{ fontSize: "0.78rem", marginTop: "6px", opacity: 0.9 }}>
                        <span style={{ marginRight: "18px" }}><strong>Ciudad:</strong> {this.state.city}</span>
                        <span><strong>Fecha Evento:</strong> {this.state.eventDate}</span>
                      </div>
                    </div>

                    {/* Datos del Cliente */}
                    <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                      <thead>
                        <tr>
                          <th colSpan="4" style={{ background: "#f1eee9", color: "#6e645a" }}>Datos del Cliente</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.pairRows(this.state.customerinfo).map((row, i) => (
                          <tr key={i}>
                            <td className="xext-rt-label">{row[0]}</td>
                            <td>{row[1]}</td>
                            <td className="xext-rt-label">{row[2]}</td>
                            <td>{row[3]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Origen y Destino */}
                    <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                      <thead>
                        <tr>
                          <th colSpan="4" style={{ background: "#f1eee9", color: "#6e645a" }}>Origen y Destino del Envío</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="xext-rt-label">Tienda</td>
                          <td>{this.state.storeName}</td>
                          <td className="xext-rt-label">Dirección</td>
                          <td>{this.state.eventAddress}</td>
                        </tr>
                        <tr>
                          <td className="xext-rt-label">Fecha Evento</td>
                          <td>{this.state.eventDate}</td>
                          <td className="xext-rt-label">Fecha Entrega</td>
                          <td>{this.state.deliveryDate}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Detalle de productos */}
                    <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                      <thead>
                        <tr>
                          <th colSpan="8" style={{ background: "#6e645a" }}>Detalle de Productos</th>
                        </tr>
                        <tr style={{ background: "#f1eee9" }}>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>Tienda Registro</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>ORDERID</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>TRX</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>SKU</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>Descripción</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>Unidades</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>Observaciones</th>
                          <th style={{ background: "#f1eee9", color: "#6e645a" }}>Check</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.orderskus.filter((sku) => sku.sendstore !== "CLIENTE").map((sku, i) => (
                          <tr key={i}>
                            <td>{sku.STORE || sku.STORENAME}</td>
                            <td>{sku.ORDERID}</td>
                            <td>{sku.TRX}</td>
                            <td>{sku.SKU}</td>
                            <td>{sku.PRODUCTNAME}</td>
                            <td className="text-right">{sku.QUANTITY}</td>
                            <td></td>
                            <td style={{ textAlign: "center" }}>
                              <input checked={false} value="YES" type="checkbox" readOnly />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Firmas */}
                    <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
                      <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", flex: 1, minHeight: "70px", padding: "10px 14px" }}>
                        <div style={{ color: "#64748b", fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase" }}>Entregado por</div>
                        <div style={{ color: "#94a3b8", fontSize: "0.72rem", marginTop: "36px" }}>Firma, Nombre y C.I.</div>
                      </div>
                      <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", flex: 1, minHeight: "70px", padding: "10px 14px" }}>
                        <div style={{ color: "#64748b", fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase" }}>Recibido por</div>
                        <div style={{ color: "#94a3b8", fontSize: "0.72rem", marginTop: "36px" }}>Firma, Nombre y C.I.</div>
                      </div>
                    </div>
                  </div>
                </MDBCol>
              </MDBRow>
            </>
          ) : (
            ""
          )}

          <ToastContainer
            hideProgressBar={true}
            newestOnTop={false}
            position={"bottom-right"}
            autoClose={3000}
          />
        </MDBContainer>
      </>
    );
  }
}
export default reportArqueo3;
